import axios from '../config/axiosConfig';

const API_URL = '/teams/';

// Get all teams
const getTeams = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get single team
const getTeam = async (teamId) => {
  const response = await axios.get(API_URL + teamId);
  return response.data;
};

// Create team (admin only)
const createTeam = async (teamData) => {
  const response = await axios.post(API_URL, teamData);
  return response.data;
};

// Update team (admin only)
const updateTeam = async (teamId, teamData) => {
  const response = await axios.put(API_URL + teamId, teamData);
  return response.data;
};

// Delete team (admin only)
const deleteTeam = async (teamId) => {
  const response = await axios.delete(API_URL + teamId);
  return response.data;
};

// Add member to team (admin only)
const addMember = async (teamId, userId, role = 'member') => {
  const response = await axios.post(API_URL + teamId + '/members', { userId, role });
  return response.data;
};

// Update member role (admin only)
const updateMemberRole = async (teamId, memberId, role) => {
  const response = await axios.put(API_URL + teamId + '/members/' + memberId, { role });
  return response.data;
};

// Remove member from team (admin only)
const removeMember = async (teamId, memberId) => {
  const response = await axios.delete(API_URL + teamId + '/members/' + memberId);
  return response.data;
};

// Get available users to add to team (admin only)
const getAvailableUsers = async (teamId) => {
  const response = await axios.get(API_URL + teamId + '/available-users');
  return response.data;
};

const teamService = {
  getTeams,
  getTeam,
  createTeam,
  updateTeam,
  deleteTeam,
  addMember,
  updateMemberRole,
  removeMember,
  getAvailableUsers
};

export default teamService;
